import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { APP } from 'utils/constants'
import strings from 'utils/strings'
import { stylesIf } from 'utils/styles'
import { Paragraph } from 'components/patterns'

const StyledParagraph = styled(Paragraph)(
  (props) => `
  ${stylesIf(props.level === APP, `transform: translateY(-100px);`)}
`
)

const NotFoundError = ({ message }) => (
  <StyledParagraph size="large" weight="bold">
    {message || strings.not_found_error_message}
  </StyledParagraph>
)

NotFoundError.propTypes = {
  message: PropTypes.string,
}

export default NotFoundError
